import "../../../Styles/Informations.css";

const SHOP_INFO: { label: string; value: string }[] = [
  { label: "Pun naziv pravnog subjekta", value: "DAROTEKA DORO" },
  { label: "Adresa", value: "Nikole Pašića 7, Novi Sad" },
  {
    label: "Delatnost i šifra delatnosti",
    value: "3212 — Proizvodnja nakita i srodnih predmeta",
  },
  { label: "Matični broj", value: "52404860" },
  { label: "Poreski broj (PIB)", value: "101705556" },
  { label: "Kontakt telefon", value: "0605500750" },
  { label: "Kontakt e-mail", value: "silvershopdoro@gmail.com" },
];

const Informations = () => {
  return (
    <section className="shop-info">
      <div className="shop-info-inner">
        <h4 className="shop-info-title">Daroteka Doro</h4>
        <dl className="shop-info-grid">
          {SHOP_INFO.map((item) => (
            <div className="shop-info-item" key={item.label}>
              <dt className="shop-info-label">{item.label}</dt>
              <dd className="shop-info-value">{item.value}</dd>
            </div>
          ))}
        </dl>
        <div className="shop-info-bottom">
          <span>© {new Date().getFullYear()} Jewelry Shop Doro — Sva prava zadržana</span>
          <span>Novi Sad, Srbija</span>
        </div>
      </div>
    </section>
  );
};

export default Informations;
